import useGet from "./read/useGet";

const useGetUserCompanies = () => {
  const {
    list: userCompaniesList,
    paramsObject,
    setGetListParams,
  } = useGet({
    url: "user/companies_list",
    initialData: "",
    isIncludeCompanyId: false,
  });
  return { userCompaniesList, paramsObject, setGetListParams };
};

export default useGetUserCompanies;
